import { render, staticRenderFns } from "./ResumoTag.vue?vue&type=template&id=3ff02376&scoped=true&lang=pug"
import script from "./ResumoTag.vue?vue&type=script&lang=js"
export * from "./ResumoTag.vue?vue&type=script&lang=js"
import style0 from "./ResumoTag.vue?vue&type=style&index=0&id=3ff02376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff02376",
  null
  
)

export default component.exports